import { Link, NavLink } from 'react-router-dom';
import { contactEmail, practices, serviceArea } from '../../data/homeContent';
import { primaryNav, servicePages } from '../../data/navigation';
import { Wordmark } from '../Art';
import styles from './Footer.module.css';

const currentYear = new Date().getFullYear();

export function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.lead}>
          <Wordmark size="footer" className={styles.mark} />
          <p className={styles.statement}>
            Software, made to <em>measure.</em>
          </p>
          <a className={styles.email} href={`mailto:${contactEmail}`}>
            {contactEmail}
          </a>
          <p className={styles.place}>Metro Detroit, Michigan · Working with teams across the U.S.</p>
        </div>

        <nav className={styles.columns} aria-label="Footer">
          <div>
            <h2 className={styles.heading}>Practice</h2>
            <ul>
              {practices.map(({ id, name }) => (
                <li key={id}>
                  <Link to={`/#${id}`}>{name}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h2 className={styles.heading}>Services</h2>
            <ul>
              {servicePages.map(({ to, label }) => (
                <li key={to}>
                  <NavLink to={to}>{label}</NavLink>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h2 className={styles.heading}>Studio</h2>
            <ul>
              {primaryNav.map(({ to, label }) => (
                <li key={to}>
                  <Link to={to}>{label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </nav>
      </div>

      <div className={styles.base}>
        <p>© {currentYear} Shumunov Solutions</p>
        <p className={styles.area}>Serving {serviceArea.slice(0, 6).join(', ')} and beyond</p>
      </div>
    </footer>
  );
}
